// Centralized config helpers for web app

function normalizePath(path: string): string {
  // Ensure no trailing slash
  return path.replace(/\/$/, '');
}

export function getApiBaseUrl(): string {
  let raw = (process.env.REACT_APP_API_URL || '') as string;
  // Fallback to default if not provided
  if (!raw) {
    raw = '/api';
  }

  // If given an absolute URL, just normalize and return
  if (/^https?:\/\//i.test(raw)) {
    return normalizePath(raw);
  }

  // If given a relative path starting with /, use it as-is with the current origin
  // This ensures /api goes to origin/api regardless of the homepage path
  if (raw.startsWith('/')) {
    return normalizePath(`${window.location.origin}${raw}`);
  }

  // Any other form: treat as path segment under origin
  return normalizePath(`${window.location.origin}/${raw.replace(/^\//, '')}`);
}
